import { FormConfig } from 'components/common/form/FormConfig';
import { useMemo } from 'react';
import { FormContent } from 'components/common/form/Form';
import i18n from 'i18n';

export const ChannelGroupSpecialSettingsForm: React.FC = () => {
  const specialSettingsFormConfig = useMemo(() => {
    return new FormConfig.Builder()
      .addSection(
        new FormConfig.SectionBuilder(
          new FormConfig.FieldsBuilder()
            .addFormikSwitch({
              label: i18n.t('channelGroupForm.labels.supportWeatherTargeting'),
              name: 'addonFeatures.campaign.supportWeatherTargeting'
            })
            .build()
        )
          .withTitle(i18n.t('channelGroups.titles.specialSettingsContent'))
          .build()
      )
      .build();
  }, []);

  return <FormContent formConfig={specialSettingsFormConfig} />;
};
